import React from 'react';
import './PropertyAdvantage.css';

// Importing icons - Assuming generic numbering for now, User can swap.
// Ideally usage: 1=Verified(Shield), 2=Transparent(Chart), 3=Support(Phone)
// If these don't exist, we will use placeholders or just img tags with alt.
import icon1 from '../../assets/icons/1.png';
import icon2 from '../../assets/icons/2.png';
import icon3 from '../../assets/icons/3.png';

const PropertyAdvantage = () => {
    return (
        <section className="property-advantage-section">
            <div className="property-advantage-container">
                {/* Left Column */}
                <div className="pa-left">
                    <span className="pa-badge">Jeevan Realty</span>
                    <h2 className="pa-title">Your Property<br />Partner<br />Advantage!</h2>
                    <div className="pa-divider"></div>
                </div>

                {/* Right Column */}
                <div className="pa-right">

                    {/* Card 1 */}
                    <div className="pa-card">
                        <div className="pa-icon-wrapper">
                            <img src={icon1} alt="Verified Properties" />
                        </div>
                        <h3 className="pa-card-title">Verified Properties</h3>
                        <p className="pa-card-text">
                            Only trusted and verified properties, no risks attached.
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div className="pa-card">
                        <div className="pa-icon-wrapper">
                            <img src={icon2} alt="Transparent Process" />
                        </div>
                        <h3 className="pa-card-title">Transparent Process</h3>
                        <p className="pa-card-text">
                            Clear communication at every stage. No Hidden Costs, No Surprises, Just Trust.
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div className="pa-card">
                        <div className="pa-icon-wrapper">
                            <img src={icon3} alt="End to End Support" />
                        </div>
                        <h3 className="pa-card-title">End to End Support</h3>
                        <p className="pa-card-text">
                            From financing to registration, we handle every detail.
                        </p>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default PropertyAdvantage;
